var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25H7.5C6.90326 8.25 6.33097 8.48705 5.90901 8.90901C5.48705 9.33097 5.25 9.90326 5.25 10.5V19.5C5.25 20.0967 5.48705 20.669 5.90901 21.091C6.33097 21.5129 6.90326 21.75 7.5 21.75H16.5C17.0967 21.75 17.669 21.5129 18.091 21.091C18.5129 20.669 18.75 20.0967 18.75 19.5V10.5C18.75 9.90326 18.5129 9.33097 18.091 8.90901C17.669 8.48705 17.0967 8.25 16.5 8.25H15M9 12L12 15M12 15L15 12M12 15V2.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25H7.5C6.90326 8.25 6.33097 8.48705 5.90901 8.90901C5.48705 9.33097 5.25 9.90326 5.25 10.5V19.5C5.25 20.0967 5.48705 20.669 5.90901 21.091C6.33097 21.5129 6.90326 21.75 7.5 21.75H16.5C17.0967 21.75 17.669 21.5129 18.091 21.091C18.5129 20.669 18.75 20.0967 18.75 19.5V10.5C18.75 9.90326 18.5129 9.33097 18.091 8.90901C17.669 8.48705 17.0967 8.25 16.5 8.25H15M9 12L12 15M12 15L15 12M12 15V2.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b4a7219b3cb0bed86aeb23d73e4a2feb.svg";
export { ForwardRef as ReactComponent };